import { submitForm } from 'app/schema-form/actions';
import { connect } from 'react-redux';
import { createPublishTarget } from '../../actions';
import CreatePublishTarget from './create-publish-target';

export default connect(null, { createPublishTarget, submitForm })(CreatePublishTarget);
export { default as formReducer } from './reducer';
